export default __webpack_public_path__ + "static/media/sync.af4193e0.png";